<template>
    <div>
        <v-dialog
            v-model="is_show"
            persistent
            max-width="600px"
        >
            <v-card>
                <v-card-title>
                    <span class="text-h5">Elimina Documento Condiviso</span>
                </v-card-title>
                <v-card-text>
                    <v-row class="ma-0">
                        <v-col
                            cols="12"
                        >
                            <p>L'eliminazione del documento è permanente, accertarsi di voler continuare.</p>
                        </v-col>
                        <v-col cols="12" class="text-right">
                            <v-btn
                                @click="closeModal"
                                class="ma-2"
                                :disabled="loading"
                            >
                                Chiudi
                            </v-btn>
                            <v-btn
                                @click.prevent="destroyDocument"
                                color="red"
                                class="ma-2"
                                :loading="loading"
                            >
                                Elimina
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>

export default {
    name: "delete-document",
    props: {
        is_show: {
            type: Boolean,
            default: false
        },
        documentData: Object,
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        async destroyDocument() {
            try {
                this.loading = true
                await this.$api.destroyUserDocument(this.documentData.id, this.documentData)
                this.$store.dispatch('set_alert', {msg: "Documento Eliminato con successo", type: 'success'})
                this.$emit('reload-data')
                this.closeModal()
            } catch (e) {
                this.loading = false
                this.$store.dispatch('set_alert', {msg: "error", type: 'error'})
            }
        },
        closeModal() {
            this.$emit('close');
            this.loading = false
        }
    }
}
</script>

<style scoped>

</style>